'use client';

import { t } from '@lingui/macro';
import CloseIcon from '@mui/icons-material/Close';
import { Typography } from '@mui/material';
import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';
import Box from '@mui/material/Box';
import Collapse from '@mui/material/Collapse';
import IconButton from '@mui/material/IconButton';
import { useMe } from '@prismo-io/feature-auth/providers/me';
import { type FC, useState } from 'react';
type Props = {
  userUrl: string;
  isVisible?: boolean;
  title?: string;
  message?: string;
};
export const RetakeDisclaimerBanner: FC<Props> = (props: Props) => {
  const {
    userUrl,
    isVisible = false,
    title = t`Repassage de Helio`,
    message = t`Les valeurs motivationnelles profondes sont plus ancrées que les compétences comportementales. Ces valeurs peuvent évoluer au cours de la vie mais surtout en fonction d'évènements majeurs. Il n'est donc pas nécessaire de repasser Helio trop régulièrement.`
  } = props;
  const me = useMe();
  const isMe = me && me.url === userUrl;
  const [open, setOpen] = useState(true);
  if (!isVisible || !isMe) return null;
  return <Box component="div" display={{
    none: 'none',
    md: 'block'
  }} data-sentry-element="Box" data-sentry-component="RetakeDisclaimerBanner" data-sentry-source-file="index.tsx">
      <Collapse in={open} data-sentry-element="Collapse" data-sentry-source-file="index.tsx">
        <Alert severity="info" action={<IconButton aria-label="close" color="inherit" size="small" onClick={() => {
        setOpen(false);
      }}>
              <CloseIcon fontSize="inherit" />
            </IconButton>} sx={{
        marginX: 2,
        marginBottom: 2
      }} data-sentry-element="Alert" data-sentry-source-file="index.tsx">
          <AlertTitle data-sentry-element="AlertTitle" data-sentry-source-file="index.tsx">{title}</AlertTitle>
          <Typography data-sentry-element="Typography" data-sentry-source-file="index.tsx">{message}</Typography>
        </Alert>
      </Collapse>
    </Box>;
};